export class MaximapModes {
    static D2 = "2D";
    static D3 = "3D";

}

